import {FC, useEffect, useState} from "react";
import ReactMarkdown from "react-markdown";
import "./TextContent.scss";

const TextContent: FC = () => {
	const [siteTexts, setSiteTexts] = useState<string | undefined>(undefined)
	const setLinkAttributes = () => {
		const link = document.querySelector('.text-content > p > a') as HTMLAnchorElement | null;
		if(link){
			link.setAttribute("target", "__blank")
			link.setAttribute("rel", "noopener noreferrer")
		}
	}

	useEffect(() => {
		fetch("./siteData.md").then(a => a.text()).then(setSiteTexts)
	},[])

	useEffect(() => {
		setLinkAttributes();
	},[siteTexts])

	return(
		siteTexts ? (
			<div className="text-content">
				<ReactMarkdown>{siteTexts}</ReactMarkdown>
			</div>
		) : null
	)
}
export default TextContent